import { Tab, Tabs, Typography } from '@mui/material';
import React from 'react';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';

import TabCash from '../Tabs/TabCash';
import TabBank from '../Tabs/TabBank';

const ReceiptVoucherFor = (props) => {
    const handleChange = (event, newValue) => {
        props.setTabValue(newValue);
    };

    function checkMethod(list) {
        for (let i = 0; i < list.length; i++) {
            if (list[i].receiptCashUSD !== undefined && list[i].receiptCashIDR !== undefined) {
                if (list[i].receiptCashUSD > 0 || list[i].receiptCashIDR > 0) {
                    return 1;
                }
            }

            if (list[i].receiptBankUSD !== undefined && list[i].receiptBankIDR !== undefined) {
                if (list[i].receiptBankUSD > 0 || list[i].receiptBankIDR > 0) {
                    return 2;
                }
            }
        };

        return 0;
    }

    return (
        <div>
            <form>
                <div>
                    <Typography
                        sx={{
                            color: 'var(--Blue-Primary-1, #083A50)',
                            fontFamily: 'Nunito',
                            fontSize: '18px',
                            fontStyle: 'normal',
                            fontWeight: '600',
                            lineHeight: 'normal',
                        }}
                    >
                        Payment Method
                    </Typography>

                    <div style={{ marginTop: '16px' }}>
                        <TabContext value={props.tabValue} className='p-0'>
                            <Tabs
                                sx={{ width: '100%', height: 'fit-content', maxHeight: '32px !important' }}
                                value={props.tabValue}
                                onChange={handleChange}
                                className='p-0'
                                textColor="primary"
                                aria-label="full width tabs example"
                                variant="fullWidth"
                                TabIndicatorProps={{
                                    sx: {
                                        height: 'fit-content !important',
                                        maxHeight: '32px !important',
                                        backgroundColor: "#0087C2 !important",
                                    },
                                }}
                                TabScrollButtonProps={{
                                    sx: {
                                        backgroundColor: "#0087C2 !important",
                                        height: 'fit-content !important',
                                        maxHeight: '32px !important',
                                    },
                                }}
                            >
                                <Tab
                                    sx={{
                                        padding: '4px 12px !important',
                                        minHeight: '35px',
                                        textTransform: "none",
                                        backgroundColor: '#D7F0FF',
                                        '&.Mui-selected': {
                                            color: '#f2f2f2',
                                            backgroundColor: '#0087C2',
                                        },
                                    }}
                                    value="Cash"
                                    label={
                                        <Typography
                                            sx={{
                                                color: props.tabValue === "Cash" ? '#F2FAFF' : '#083A50',
                                                fontFamily: 'Nunito',
                                                fontSize: '14px !important',
                                                fontStyle: 'normal',
                                                fontWeight: '600',
                                            }}
                                        >
                                            Cash
                                        </Typography>
                                    }
                                />
                                <Tab
                                    sx={{
                                        padding: '4px 12px !important',
                                        minHeight: '35px',
                                        textTransform: "none",
                                        backgroundColor: '#D7F0FF',
                                        '&.Mui-selected': {
                                            color: '#f2f2f2',
                                            backgroundColor: '#0087C2',
                                        },
                                    }}
                                    value="Bank"
                                    label={
                                        <Typography
                                            sx={{
                                                color: props.tabValue === "Bank" ? '#F2FAFF' : '#083A50',
                                                fontFamily: 'Nunito',
                                                fontSize: '14px !important',
                                                fontStyle: 'normal',
                                                fontWeight: '600',
                                            }}
                                        >
                                            Bank
                                        </Typography>
                                    }
                                />
                            </Tabs>

                            {
                                props.tabValue === 'Cash' && (
                                    <TabPanel value="Cash" className='mt-1 p-0'>
                                        <TabCash
                                            Rate={props.Rate}
                                            isApprovedAcc={props.isApprovedAcc}
                                            checkMethod={checkMethod}
                                            calculateTotalDebitCredit={props.calculateTotalDebitCredit}
                                            CashPaymentUSD={props.CashPaymentUSD}
                                            setCashPaymentUSD={props.setCashPaymentUSD}
                                            CashPaymentIDR={props.CashPaymentIDR}
                                            setCashPaymentIDR={props.setCashPaymentIDR}
                                            selectedReceiptVoucher={props.selectedReceiptVoucher}
                                            receiptVoucherId={props.receiptVoucherId}
                                            DataReceiptVoucher={props.DataReceiptVoucher}
                                            setDataReceiptVoucher={props.setDataReceiptVoucher}
                                            TotalCashUSD={props.TotalCashUSD}
                                            setTotalCashUSD={props.setTotalCashUSD}
                                            TotalCashIDR={props.TotalCashIDR}
                                            setTotalCashIDR={props.setTotalCashIDR}
                                        />
                                    </TabPanel>
                                )
                            }

                            {
                                props.tabValue === 'Bank' && (
                                    <TabPanel value="Bank" className='mt-1 p-0'>
                                        <TabBank
                                            receiptVoucherId={props.receiptVoucherId}
                                            isApprovedAcc={props.isApprovedAcc}
                                            calculateTotalDebitCredit={props.calculateTotalDebitCredit}
                                            checkMethod={checkMethod}
                                            BankData={props.BankData}
                                            setBankData={props.setBankData}
                                            selectedReceiptVoucher={props.selectedReceiptVoucher}
                                            Rate={props.Rate}
                                            DataReceiptVoucher={props.DataReceiptVoucher}
                                            setDataReceiptVoucher={props.setDataReceiptVoucher}
                                            TotalBankUSD={props.TotalBankUSD}
                                            setTotalBankUSD={props.setTotalBankUSD}
                                            TotalBankIDR={props.TotalBankIDR}
                                            setTotalBankIDR={props.setTotalBankIDR}
                                        />
                                    </TabPanel>
                                )
                            }
                        </TabContext>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default ReceiptVoucherFor;